import React from 'react';
import { observer } from 'mobx-react';
import Draggable from 'react-draggable';
import { Modal, ModalHeader, ModalBody, ModalFooter, Container } from 'reactstrap';

interface IInformationProps {
  onClickInformation: any;
  onClickInformationToggle: any;
  errorCode: string;
  selectedReachId: string;
	errorMessage: string;
}

const OnClickReachInformationComponent = (props: IInformationProps) => {
  return (
		<div>
			<Draggable axis="both" positionOffset={{ x: '0%', y: '100%' }} cancel="button,input">
				<Modal
					isOpen={props.onClickInformation}
					toggle={props.onClickInformationToggle}
					centered={false}
					className="eft-action-modal"
					ariaLabel="Information"
					backdrop={false}
				>
					<ModalHeader className='header-info-detail'>
						<div className="display-flex flex-align-center">
							<h1>{`Information`}</h1>
						</div>
					</ModalHeader>
					<ModalBody>
						<Container className='modal-description'>
							<p className='modal-description-item'><strong>Error Code: {props.errorCode}</strong></p>
							<p className='modal-description-item'><strong>Reach: {props.selectedReachId}</strong></p>
							<p className='modal-description-description'>{props.errorMessage}</p>
						</Container>
					</ModalBody>
					<ModalFooter>
						<button className="usa-button" onClick={props.onClickInformationToggle}>
							Close
						</button>
					</ModalFooter>
				</Modal>
			</Draggable>
		</div>
	);
};

export const OnClickReachInformation = observer(OnClickReachInformationComponent);